export default {
  defaultModele: "Standardvorlage",
  studea_manager: {
    confirm_duplication: "Sind Sie sicher, dass Sie diese Daten duplizieren möchten?",
    data_duplicated_success: "Daten erfolgreich dupliziert",
    delete_session_confirmation: "Sind Sie sicher, dass Sie diesen Zeitraum löschen möchten?",
    delete_referential_confirmation: "Sind Sie sicher, dass Sie dieses Referenzwerk löschen möchten?",
    navigation: {
      general: "Allgemein",
      modules: "Module",
      pilotage: "Steuerung",
    },
    triadUser: {
      title: "sekundärer Benutzer",
    },
    moderation: {
      title: ({ plural }) => plural(["Meldung", "Meldungen"]),
      censor: "Zensieren",
      restore: "Meldung aufheben",
      show: "Anzeigen",
      show_censor: "Zensierte Nachrichten anzeigen",
      show_message: "Zu moderierende Nachrichten anzeigen",
      file: "Datei",
      modal_title: "Gespräch",
      alert_title: "Eine Nachricht zensieren",
      alert_sub_title: "Möchten Sie diese Nachricht zensieren oder die Meldung aufheben?",
      censor_success: "Nachricht erfolgreich zensiert!",
    },
    home: {
      title: ({ plural }) => plural(["Konfiguration der ", "Konfiguration des "]),
      page_title: "Konfiguration",
    },
    questionnaire: {
      title: ({ plural }) => plural(["Fragebogen", "Fragebögen"]),
      list: {
        title: "Konfiguration der Fragebögen",
      },
      questionnaire_already_signed: "Achtung, der Fragebogen wurde bereits unterzeichnet!",
      start_date: ({ named }) => `Zugangsdatum ${named("profile")} - vom`,
      end_date: "bis",

      finish: {
        title: "Meine Konfiguration abschließen",
      },
      empty_title: "Um zu beginnen, fügen Sie bitte einen Titel, eine Frage oder ein Antwortfeld hinzu!",
      add_question: "Eine Frage hinzufügen",
      add_title: "Einen Titel hinzufügen",
      add_question_cluster: "Ein Fragenraster hinzufügen",
      required: "Pflichtfeld",
      question_settings: "Fragenparameter",
      question_access: "Zugriffsparameter",
      cluster_settings: "Rasterparameter",
      remove_question: "Frage löschen",
      remove_cluster: "Raster löschen",
      remove_title: "Titel löschen",
      duplicate_cluster: "Raster duplizieren",
      duplicate_question: "Frage duplizieren",
      tip: "Infobox",
      display_mode: "Antwortfeld",
      save: "Speichern",
      save_success: "Fragebogen erfolgreich gespeichert!",
      save_error: "Beim Speichern ist ein Fehler aufgetreten!",
      missing_error: "Achtung, bei einigen Fragen fehlen Zugriffsrechte oder Titel!",
      informations: "Informationen",
      deadlines_reminders: "Fristen & Erinnerungen",
      advanced_parameter: "Erweiterte Parameter",
      company_visit: "Unternehmensbesuch",
      settings: "Parameter",
      summary: "Zusammenfassung",
      add_column: "Eine Spalte hinzufügen",
      add_row: "Eine Zeile hinzufügen",
      row_settings: "Wer füllt aus?",
      skill_settings: "Verknüpfte Kompetenzen verwalten",
      access_missing: "Die Zugriffsrechte fehlen für diese Frage",
      title_missing: "Sie müssen einen Titel für diese Frage angeben",
      value_title_missing: "Sie müssen einen Titel für diesen Wert angeben",
      duplicate_row: "Zeile duplizieren",
      remove_row: "Zeile löschen",
      remove_column: "Spalte löschen",
      empty_line: "Zeile ohne Titel",
      add_skill: "Diese Kompetenz hinzufügen",
      skill_category_name: "Kategorie",
      skill_name: "Name",
      coefficient: "Koeffizient",
      empty_column: "Spaltentitel",
      remove_field_skill: "Verknüpfte Kompetenz entfernen",
      field_skill_used: "Diese Kompetenz ist bereits mit dieser Frage verknüpft",
      remove_field_skill_sub:
        "Sind Sie sicher, dass Sie die Verknüpfung dieser Kompetenz mit der Frage entfernen möchten?",
      untitled_column: "Spalte ohne Titel",
      remove_row_warning: "Sind Sie sicher, dass Sie diese Zeile löschen möchten?",
      remove_column_warning: "Sind Sie sicher, dass Sie diese Spalte löschen möchten?",
      untitled_questionnaire: "Formular ohne Titel",
      placeholder_description: "Ihre Beschreibung hinzufügen",
      access_profil: "Profile, die die Frage beantworten",
      field_skill: "Mit der Frage verknüpfte Kompetenzen",
      search_skill: "Eine Kompetenz suchen",
      opened_question_access: "Zugang zu offenen Fragen",
      opened_questions: "Offene Fragen",
      opened_questions_type: "Art der offenen Fragen",
      grid_title: "Rastertitel",
      comments_enabled: "Kommentare erlaubt",
      comments_label: "Bezeichnung der Kommentare",
      comments_type: "Art der Kommentarfelder",
      one_line: "Kurze Antwort",
      multi_line: "Textbereich",
      maximal_mark: "Höchstnote",
      mark_scale: "Notenskala",
      display_mark: "Noten verwenden",
      display_radar: "Radar anzeigen",
      question_title: "Fragentitel",
      infobulle_content: "Inhalt der Infobox",
      question_comment: "Kommentar",
      field_type_choose: "Einen Typ auswählen",
      short_answer: "Kurze Antwort",
      long_answer: "Lange Antwort",
      textarea: "Textbereich",
      number: "Zahl",
      dropdown_list: "Dropdown-Liste",
      unique_choice: "Einzelne Auswahl",
      multiple_choices: "Mehrfachauswahl",
      file: "Datei",
      date: "Datum",
      question: ({ plural }) => plural(["Frage", "Fragen"]),
      date_time: "Datum und Uhrzeit",
      remove_question_warning: "Sind Sie sicher, dass Sie diese Frage löschen möchten?",
      option: "Option",
      untitled_cluster: "Raster ohne Titel",
      untitled_title: "Titel",
      title_label: "Titel",
      remove_cluster_warning: "Sind Sie sicher, dass Sie dieses Raster löschen möchten?",
      value: "Wert",
      choose_option: "Eine Option auswählen",
      questionnaire_settings: "Fragebogen-Konfiguration",
      confirm: "Bestätigen",
      cancel: "Abbrechen",
      rights: "Rechte",
      notes_summary: "Noten und Zusammenfassung",
      option_placeholder: "Option",
      value_placeholder: "Note",
      comment_placeholder: "Einen Kommentar hinzufügen",
      option_settings: "Optionskonfiguration",
      columns: "Spalten",
      active: "Aktiv",
      unable: {
        confirmation: "Sind Sie sicher, dass Sie diesen Fragebogen aktivieren möchten?",
        success: "Fragebogen erfolgreich aktiviert!",
      },
      disable: {
        confirmation: "Sind Sie sicher, dass Sie diesen Fragebogen deaktivieren möchten?",
        success: "Fragebogen erfolgreich deaktiviert!",
      },
      global_export_visibility: "Im globalen Export des Hefts sichtbar",
    },
    category: {
      title: ({ plural }) => plural(["Kategorie", "Kategorien"]),
      add: "Eine Kategorie hinzufügen",
      delete_with_links: {
        title: "Verknüpfte Kategorie löschen",
        sub_title:
          "Diese Kategorie ist mit Fragebögen verknüpft. Sie müssen diese Fragebögen löschen, bevor Sie diese Kategorie löschen können. Möchten Sie wirklich fortfahren?",
        success: "Verknüpfte Kategorie erfolgreich gelöscht!",
      },
    },
    group: {
      title: ({ plural }) => plural(["Gruppe", "Gruppen"]),
    },
    training: {
      title: ({ plural }) => plural(["Ausbildung", "Ausbildungen"]),
      go_to_list: "Zur Liste der Ausbildungen gehen",
    },
    webLink: {
      title: ({ plural }) => plural(["Nützlicher Link", "Nützliche Links"]),
    },
    trainingCourse: {
      title: ({ plural }) => plural(["Gruppe", "Gruppen"]),
    },
    skill: {
      title: ({ plural }) => plural(["Kompetenz", "Kompetenzen"]),
      list: {
        title: "Konfiguration der Kompetenzen",
        empty: "Es gibt noch keine Kompetenz in dieser Ausbildung. Bitte erstellen Sie zunächst eine Kategorie.",
        empty_only: "Es sind noch keine Kompetenzen eingetragen",
      },
      actions: {
        add: "Eine Kompetenz hinzufügen",
        module_actions: "Konfiguration",
        skill_actions: "Kompetenzen verwalten",
        session_actions: "Zeiträume verwalten",
        import_export_actions: "Import/Export",
        reminder_actions: "Erinnerungen",
      },
      name: "Name",
      level: "Erforderliches Niveau",
      default: {
        not_acquired: "Nicht erworben",
        acquired: "Erworben",
        expert: "Experte",
        being_acquired: "Im Erwerb",
        insufficient_mastery: "Unzureichende Beherrschung",
        partial_mastery: "Teilweise Beherrschung",
        average_mastery: "Mittlere Beherrschung",
        good_mastery: "Gute Beherrschung",
        excellent_mastery: "Ausgezeichnete Beherrschung",
      },
    },
    skill_configuration: {
      title: "Modulkonfiguration",
      success: "Konfiguration erfolgreich aktualisiert!",
      use_admin: "Admin-Konfiguration verwenden?",
      warning:
        "Achtung! Sie müssen die Konfiguration des Kompetenzmoduls abschließen, bevor Sie ein Referenzwerk integrieren können.",
    },
    skill_referential: {
      title: "Verwaltung der Kompetenzreferenzwerke",
      success: "Referenzwerke erfolgreich aktualisiert!",
      warning:
        "Achtung! Sie müssen die Konfiguration des Kompetenzmoduls abschließen, bevor Sie ein Referenzwerk integrieren können.",
      empty_add: "Es gibt noch kein Referenzwerk. Klicken Sie auf '+', um eines hinzuzufügen.",
    },
    skill_generate: {
      title: "Einen Fragebogen aus den Kompetenzen generieren",
      success: "Fragebogen erfolgreich generiert!",
    },
    skill_remove: {
      title: "Referenzwerk löschen (ohne die Fragebögen)",
      sub_title: "Sind Sie sicher, dass Sie das Referenzwerk löschen möchten?",
      success: "Referenzwerk erfolgreich gelöscht!",
    },
    skill_import: {
      title: "Ihre Kompetenzen importieren",
      success: "Kompetenzen erfolgreich importiert!",
    },
    skill_import_france_competence: {
      title: "Das France Compétences-Referenzwerk importieren",
      confirm: "Sind Sie sicher, dass Sie das France Compétences-Referenzwerk in diese Ausbildung laden möchten?",
      success: "Referenzwerk erfolgreich importiert!",
    },
    skill_export: {
      title: "Kompetenzen exportieren",
      success: "Kompetenzen erfolgreich exportiert!",
    },
    skill_export_taught: {
      title: "Fächer exportieren",
      success: "Fächer erfolgreich exportiert!",
    },
    skillSession: {
      gestion: "Verwaltung der Kompetenzzeiträume",
      list: {
        title: "Konfiguration der Zeiträume",
        empty: "Es gibt noch keinen Zeitraum. Klicken Sie auf '+', um einen hinzuzufügen.",
      },
      title: ({ plural }) => plural(["Zeitraum", "Zeiträume"]),
    },
    skillReferential: {
      title: ({ plural }) => plural(["Referenzwerk", "Referenzwerke"]),
      use: "Ein Referenzwerk verwenden",
    },
    skillCategory: {
      title: ({ plural }) => plural(["Kategorie", "Kategorien"]),
    },
    skin: {
      title: ({ plural }) => plural(["Design", "Designs"]),
      list: {
        title: "Design",
      },
    },
    gradebook: {
      title: ({ plural }) => plural(["Notenzeugnis", "Notenzeugnisse"]),
      global_config: "Kopf- und Fußzeile",
      session_config: "Konfiguration der Zeiträume",
      exam_type: "Liste der Prüfungstypen",
      start_date: "Öffnungsdatum: ",
      end_date: "Schließungsdatum: ",
      empty_session: "Es gibt noch keinen Zeitraum. Bitte fügen Sie einen hinzu.",
      empty_subject: "Für diesen Zeitraum ist kein Fach eingetragen. Bitte fügen Sie eines hinzu.",
      empty_exam:
        "Für dieses Fach ist keine Prüfung eingetragen. Bitte wählen Sie eine in der Fachkonfiguration aus, indem Sie hier klicken.",
      delete_session: {
        confirmation: "Sind Sie sicher, dass Sie diesen Zeitraum löschen möchten?",
        success: "Zeitraum erfolgreich gelöscht!",
      },
      delete_subject: {
        confirmation: "Sind Sie sicher, dass Sie dieses Fach aus dem Zeitraum entfernen möchten?",
        success: "Fach erfolgreich entfernt!",
      },
      delete_exam: {
        confirmation: "Sind Sie sicher, dass Sie diese Prüfung löschen möchten?",
        success: "Prüfung erfolgreich entfernt!",
      },
      scale: "Notenskala",
      set_exam_and_coef: "Prüfungstyp und Koeffizient für dieses Fach angeben",
    },
    exam: {
      title: ({ plural }) => plural(["Prüfung", "Prüfungen"]),
      type_title: "Prüfungstyp",
    },
    triad: {
      title: ({ plural }) => plural(["Trinôme", "Trinômes"]),
      list: {
        name: "Name",
        apprentice_name: "Name des Auszubildenden",
        tutor_name: "Name des pädagogischen Betreuers",
        map_name: "Name des Unternehmensbetreuers",
        gestionnary_name: "Name des Verwalters",
      },
      tutor: {
        title: ({ plural }) => plural(["Pädagogischer Betreuer", "Pädagogische Betreuer"]),
      },
      map: {
        title: ({ plural }) => plural(["Unternehmensbetreuer", "Unternehmensbetreuer"]),
      },
      questionnaire_triad_already_signed:
        "Achtung, Unterschriften von \nFragebögen sind mit \ndiesem Trinôme verknüpft",
      usurp: {
        title: "Verkörpern",
      },
      login: {
        title: "Versand der Zugangsdaten verwalten",
      },
      delete_all: {
        tutor: "Alle pädagogischen Betreuer löschen",
        map: "Alle Unternehmensbetreuer löschen",
      },
      delete: {
        tutor: "Diesen pädagogischen Betreuer löschen",
        map: "Diesen Unternehmensbetreuer löschen",
        legal_responsible: "Diesen gesetzlichen Vertreter löschen",
      },
      delete_member: {
        title: "Mitglied des Trinômes",
      },
      delete_all_tutor: {
        title: "alle pädagogischen Betreuer",
      },
      delete_all_map: {
        title: "alle Unternehmensbetreuer",
      },
      edit: {
        legal_responsible: "Diesen gesetzlichen Vertreter bearbeiten",
        tutor: "Diesen pädagogischen Betreuer bearbeiten",
      },
      contract: {
        title: "Vertragsverwaltung",
      },
      complete: {
        title: "Ein Mitglied zum Trinôme hinzufügen",
      },
      actions: {
        title: "Aktionen",
      },
      add_test: "Test-Trinôme",
      add_test_success: "Test-Trinôme erfolgreich hinzugefügt!",
      send_user_infos: "Versand der Zugangsdaten verwalten",
      send_welcome_email: "Willkommens-E-Mail mit den Zugangsdaten senden",
      send_welcome_email_success: "Willkommens-E-Mail(s) erfolgreich gesendet!",
      reset_password: "Passwort zurücksetzen und Zugangsdaten erneut senden",
      reset_password_success: "E-Mail(s) zur Passwortzurücksetzung erfolgreich gesendet!",
      send_user_infos_message:
        "Markieren Sie die Benutzer und klicken Sie auf die Art der E-Mail, die Sie senden möchten",
      add_secondary_user: "Einen sekundären Benutzer für dieses Trinôme hinzufügen",
      add_secondary_user_success: "Sekundärer Benutzer erfolgreich hinzugefügt",
      remove_secondary_user: "Sekundärer Benutzer erfolgreich gelöscht",
    },
    studeaUser: {
      title: ({ plural }) => plural(["Benutzer", "Benutzer"]),
    },
    user: {
      title: ({ plural }) => plural(["Benutzer", "Benutzer"]),
    },
    crew: {
      title: ({ plural }) => plural(["Gruppe", "Gruppen"]),
      cannot_remove: "Sie können eine Gruppe, die Trinômes enthält, nicht löschen",
    },
    contract: {
      title: ({ plural }) => plural(["Vertrag", "Verträge"]),
      empty: "Dieses Trinôme hat keinen Vertrag",
      dates: "Vertragsdaten",
      company: "Unternehmen",
      duration: "Dauer",
      address: "Adresse",
      map: "MAP",
      manager: "Verwalter",
      contrat_type: "Vertragstyp",
      rupture_date: "Auflösungsdatum",
      contract_rupture_date: "Vertrag aufgelöst am: ",
      dropped_out: "Abbruch am: ",
      rupture_reason: "Auflösungsgrund",
      rupture_reason_text: "Kommentar",
      months: "Monate",
      also_tutor: "Sie sind Betreuer dieses Trinômes",
      incident_sheet: "Für dieses Trinôme ist eine Warnmeldung aktiv",
    },
    template: {
      title: ({ plural }) => plural(["Vorlage", "Vorlagen"]),
    },
    lesson: {
      title: ({ plural }) => plural(["Kurs", "Kurse"]),
    },
    skillType: {
      title: ({ plural }) => plural(["Kompetenztyp", "Kompetenztypen", "Kompetenztypen"]),
    },
    subject: {
      title: ({ plural }) => plural(["Fach", "Fächer"]),
      former: {
        add: "Einen Dozenten hinzufügen",
        add_new: "Einen Dozenten hinzufügen, der nicht in der Liste ist",
        is_former: "Dieser Benutzer ist bereits Dozent",
        is_studea_manager: "Dieser Benutzer ist Pilot. Die Zuweisung einer neuen Rolle könnte seine Rechte ändern.",
        is_admin: "Dieser Benutzer ist Administrator. Ein Dozenten-Pilot-Profil wird ihm hinzugefügt.",
        empty:
          "Kein Benutzer gefunden. Geben Sie E-Mail, Nachname und Vorname ein, um einen neuen Dozenten zu erstellen.",
        add_success: "Dozent erfolgreich hinzugefügt",
      },
    },
    unit: {
      title: ({ plural }) => plural(["Einheit", "Einheiten"]),
    },
    planning: {
      title: ({ plural }) => plural(["Ereignis", "Ereignisse"]),
      removeSelected: {
        title: "Ausgewählte Ereignisse löschen",
        sub_title: "Sind Sie sicher, dass Sie diese Ereignisse löschen möchten?",
        sucess: "Ereignisse erfolgreich gelöscht!",
      },
      end_of_recurrence: "Ende der Wiederholung:",
    },
    trainingCourseModuleTriad: {
      title: ({ plural }) => plural(["Modul", "Module"]),
    },
    absence: {
      title: ({ plural }) => plural(["Abwesenheit", "Abwesenheiten"]),
      list: {
        title: "Anwesenheit",
      },
      config: {
        title: "Konfiguration",
        success: "Konfiguration erfolgreich geändert!",
      },
      export: {
        full_list: "Vollständige Abwesenheitsliste",
        apprentice_list: "Abwesenheitsliste nach ",
        excel: "(Excel)",
        pdf: "(PDF)",
        state: "Abwesenheitsstatus (Planung)",
      },
      attestation: {
        title: "Eine Benachrichtigung über eine neue Bescheinigung senden",
      },
    },
    module: {
      active: {
        success: "Modul erfolgreich aktiviert!",
      },
      unactive: {
        success: "Modul erfolgreich deaktiviert!",
      },
    },
    registration: {
      title: ({ plural }) => plural(["Anmeldung", "Anmeldungen"]),
      list: {
        title: "Anmeldungen",
      },
      go_to: "Zu den Anmeldungen gehen",
    },
    notepad: {
      title: ({ plural }) => plural(["Notizblock", "Notizblöcke"]),
    },
    note: {
      title: ({ plural }) => plural(["Notiz", "Notizen"]),
    },
    document: {
      title: ({ plural }) => plural(["Dokument", "Dokumente"]),
      pedagogic_documents: "Pädagogische Dokumente",
      general_documents: "Allgemeine Dokumente",
      shared_documents: "Geteilte Dokumente",
      shared_document_add: "Ein geteiltes Dokument hinzufügen",
      shared_document_edit: "Ein geteiltes Dokument bearbeiten",
      shared_document_list: "Die geteilten Dokumente",
      shared_document_info:
        "Dieses Dokument ist geteilt. Um es zu bearbeiten, \n gehen Sie bitte zur Liste der geteilten Dokumente.",
      trainingCourse_documents: "Dokumente der Gruppe",
      error_file_or_link: "Bitte fügen Sie eine Datei hinzu oder geben Sie einen Link ein",
      link: "Link",
    },
    "document/shared": {
      title: ({ plural }) => plural(["Geteiltes Dokument", "Geteilte Dokumente"]),
    },
    incident_sheet: {
      title: ({ plural }) => plural("Warnmeldung", "Warnmeldungen"),
      list: "Die Warnmeldungen",
      add_comment: "Einen Kommentar hinzufügen",
      close: "Schließen",
      close_confirmation: "Sind Sie sicher, dass Sie diese Warnmeldung schließen möchten?",
      open: "Öffnen",
      open_confirmation: "Sind Sie sicher, dass Sie diese Warnmeldung erneut öffnen möchten?",
      delete: "Löschen",
      delete_confirmation: "Sind Sie sicher, dass Sie diese Warnmeldung löschen möchten?",
      in_progress: "In Bearbeitung",
      closed: "Geschlossen",
      search: "Eine Warnmeldung suchen",
      see_sheet: "Vorfallbericht anzeigen",
      comment: "Kommentar",
      status: "Status",
      no_status: "Kein Status",
    },
    currently: "derzeit",
    documentExchange: {
      list: {
        title: "Dokumentenaustausch",
      },
    },
    messaging: {
      list: {
        title: "Nachrichten",
      },
    },
    dashboard: {
      list: {
        title: "Dashboard",
      },
      please_use_filter_to_see_data: "Bitte verwenden Sie die Filter, um die Daten anzuzeigen",
      signature_cancel_confirmation: "Sind Sie sicher, dass Sie die Unterschrift stornieren möchten?",
      filter: "Filtern",
      delete_filters: "Filter zurücksetzen",
      questionnaire: {
        unlocked_confirmation: "Möchten Sie diesen Fragebogen entsperren?",
        locked_confirmation: "Möchten Sie diesen Fragebogen sperren?",
        unlocked_all_confirmation: "Möchten Sie alle Fragebögen dieser Spalte entsperren?",
        unlock_all_questionnaires: "Alle Fragebögen dieser Spalte entsperren",
        unlock_questionnaire: "Diesen Fragebogen entsperren",
        opening_date_on: "Öffnungsdatum am",
        lock_questionnaire: "Diesen Fragebogen sperren",
        cancel_signature: "Diese Unterschrift stornieren",
        send_email_reminder: "Per E-Mail erinnern",
        send_email_reminder_confirmation: "Sind Sie sicher, dass Sie eine E-Mail-Erinnerung senden möchten?",
        send_email_reminder_success: "Erinnerungen erfolgreich gesendet!",
        success_all_unlock: "Fragebögen erfolgreich entsperrt!",
        success_unlock: "Fragebogen erfolgreich entsperrt!",
        success_lock: "Fragebogen erfolgreich gesperrt!",
        success_cancel_signature: "Unterschrift erfolgreich storniert!",
        to_much_data: "Zu viele Daten ausgewählt. Bitte grenzen Sie Ihre Suche ein.",
        table_lock: "Fragebögen fixieren",
        table_unlock: "Fragebögen nicht fixieren",
      },
      mail_relance: "E-Mail-Erinnerungen",
      email_reminder: "Per E-Mail erinnern",
      export: {
        title: "Exportieren",
        all_promotion_replies: "Alle Antworten der Gruppe exportieren",
        all_promotion_replies_to_excel: "Alle Antworten der Gruppe im Excel-Format exportieren",
        visit_date: "Unternehmensbesuchsdaten exportieren",
        dashboard_excel: "Dashboard im Excel-Format exportieren",
        questionnaires_pdf: "Fragebögen exportieren",
      },
      roles: {
        alternate: "Auszubildender",
        educational_tutor: "Pädagogischer Betreuer",
        company_tutor: "Unternehmensbetreuer",
        lea_manager: "Léa-Beauftragter",
      },
      go_to_questionnaire: "Zum Fragebogen gehen",
    },
    gradeBookDashboard: {
      list: {
        title: "Notenübersicht",
      },
      export_dashboard_excel: "Notenübersicht im Excel-Format exportieren",
      caption: {
        danger: "Note zwischen der Mindestnote und dem unteren Durchschnitt",
        success: "Note zwischen dem oberen Durchschnitt und der Höchstnote",
      },
    },
    skillDashboard: {
      list: {
        title: "Kompetenz-Dashboard",
      },
      export_dashboard_excel: "Kompetenzübersicht im Excel-Format exportieren",
      skill: {
        acquired: "Erworben",
        in_progress: "In Bearbeitung",
        not_acquired: "Nicht erworben",
      },
    },
    export: {
      list: {
        title: "Exporte",
      },
    },
    mail: {
      list: {
        title: "E-Mail-Verfolgung",
        empty: "Es wurde noch keine E-Mail gesendet",
      },
      view: "Inhalt der E-Mail anzeigen",
      data: "E-Mail-Daten",
    },
    history: {
      list: {
        title: "Verbindungsverlauf",
      },
    },
    assiduite: "Anwesenheitsverwaltung",
    subscriptions_dashboard: "Anmeldungs-Dashboard",
    import: {
      modele: "Dateivorlage zum Herunterladen",
      triad_new_file:
        "Achtung, seit dem 18.09.2023 ist eine neue Vorlage verfügbar.\n" +
        "          Bitte laden Sie diese herunter und verwenden Sie sie zum Importieren Ihrer Trinômes.",
      triad_update:
        "Achtung, nur fehlende Mitglieder eines Trinômes werden aktualisiert. Keine Daten (Name, Vorname oder E-Mail) eines bestehenden Benutzers werden aktualisiert.",
      thanks: "Bitte ändern oder löschen Sie die Spalten der Vorlage nicht",
    },
    download_file_here: "Datei HIER herunterladen",
    session: {
      from: "Vom",
      to: "bis",
      title: ({ plural }) => plural(["Zeitraum", "Zeiträume"]),
    },
    user_never_connected: "Dieser Benutzer hat sich noch nie angemeldet",
    welcome_mail_send: ({ named }) => `Willkommens-E-Mail wurde ${named("number")} Mal gesendet`,
    reset_password_mail_send: ({ named }) => `Zurücksetz-E-Mail wurde ${named("number")} Mal gesendet`,
    see_last_mail_content: "Inhalt der letzten gesendeten E-Mail anzeigen",
    duplication: "Datenduplizierung",
    duplication_historic: "Duplizierungsverlauf",
    search_duplication: "Duplizierungen suchen",
    see_duplication: "Alle Informationen zu dieser Duplizierung anzeigen",
    duplication_date: "Ausführungsenddatum",
    duplication_too_old: "Sie können eine Duplizierung, die älter als 15 Tage ist, nicht erneut starten.",
    duplication_status: {
      pending: "In Bearbeitung",
      done: "Abgeschlossen",
      failed: "Fehlgeschlagen",
    },
    reload_duplication: {
      title: "Diese Duplizierung erneut starten",
      confirmation: "Sind Sie sicher, dass Sie diese Duplizierung erneut starten möchten?",
    },
    details: "Details",
    status: "Status",
    statistic: {
      title: ({ plural }) => plural(["Statistik", "Statistiken"]),
      shared_documents: "Unvollständige Trinômes",
      calculation_in_progress: "Berechnung der Indikatoren läuft.",
      calculation_refresh:
        "Bitte warten Sie einen Moment oder aktualisieren Sie Ihre Seite, um die Berechnung zu aktualisieren.",
    },
    driver_licence: {
      title: "Führerschein B",
      requests: "Anträge auf Führerscheinförderung B",
      list: "Liste der Anträge auf Führerscheinförderung B",
      valid: "Antrag auf Förderung validieren",
      valid_confirmation: "Sind Sie sicher, dass Sie diesen Antrag validieren möchten?",
      export: "Liste der Förderanträge exportieren",
      edit: "Antrag von bearbeiten: ",
      overview: "Übersicht des Antrags von: ",
      request_edit: {
        success: "Antrag auf Führerscheinförderung B erfolgreich geändert",
      },
    },
    company: {
      title: ({ plural }) => plural(["Unternehmen", "Unternehmen"]),
    },
    apprentice: {
      title: ({ plural }) => plural(["Auszubildender", "Auszubildende"]),
    },
    duplicated: {
      relaunch: "Erneut starten",
      reference: "Referenz",
      destination: "Ziel",
      type: "Duplizierungstyp",
      confirmation: "Sind Sie sicher, dass Sie diese Daten duplizieren möchten?",
      action: {
        replace: "Ersetzen",
        add: "Hinzufügen",
        crush: "Überschreiben",
        options: {
          title: "Optionen",
          add_to_current_year: "Zum aktuellen Jahr hinzufügen",
          empty_training_course: "Nur für leere Gruppen",
          add_to_due_date: "Ein Jahr zu den Fälligkeitsdaten hinzufügen",
          overwrite_current_year_only: "Nur das aktuelle Jahr überschreiben",
        },
      },
      questionnaire: {
        already_sign_not_affected: "Bereits unterzeichnete Fragebögen werden nicht beeinträchtigt",
        copy_even_if_already_existing: "Fragebögen werden kopiert, auch wenn bereits welche vorhanden sind",
        replace_questionnaire_with_same_name_questionnaire:
          "Fragebögen mit <strong>demselben Namen</strong> werden ersetzt",
        replace_all: "Bestehende Fragebögen werden gelöscht",
      },
      training_course: {
        duplicated_data: "Duplizierte Daten",
        add_data_if_empty: "Fügt Daten hinzu, wenn sie noch nicht vorhanden sind",
        duplicate_choice: "Sie möchten duplizieren",
        duplicate_from_reference: "Ermöglicht das Kopieren eines Musterhefts auf eine Gruppe von Promotionen",
        duplicate_from_year:
          "Ermöglicht das Hinzufügen eines Jahres durch Duplizierung der Konfiguration des Vorjahres",
      },
    },
  },
  add_session: "Einen Zeitraum hinzufügen",
  edusign: {
    title: "Edusign",
    synchronize: {
      title: "Synchronisation bei Edusign starten",
      confirmation: "Sind Sie sicher, dass Sie die Synchronisation bei Edusign starten möchten?",
    },
    get_data: {
      title: "Abwesenheiten und Anwesenheiten abrufen",
      confirmation: "Sind Sie sicher, dass Sie die Abwesenheiten und Anwesenheiten von Edusign abrufen möchten?",
    },
  },
  uniservice: {
    title: "Uniservice",
    get_data: {
      title: "Anwesenheiten abrufen",
      confirmation: "Sind Sie sicher, dass Sie die Anwesenheiten von Uniservice abrufen möchten?",
    },
    reset: {
      title: "Anwesenheiten und Abwesenheiten zurücksetzen",
      confirmation:
        "Sind Sie sicher, dass Sie die Anwesenheiten und Abwesenheiten nicht validierter Planungen löschen möchten?",
    },
  },
};
